<template>
  <v-row>
    <v-col cols="12" class="d-flex align-center">
      <h2>{{ $t('commission_role.head') }}</h2>
      <v-divider class="mx-3" vertical />
      <v-breadcrumbs :items="breadcrumbsItems" divider=">>" />
    </v-col>
    <v-divider class="mx-3" vertical />
    <v-col cols="12">
      <v-card>
        <v-card-title>
          {{ $t('commission_role.head_list2') }}
          <v-spacer />
        </v-card-title>
        <v-form ref="form" v-model="formValid">
          <v-divider class="mx-3" />
          <v-card-actions>
            <v-row>
              <v-col cols="12" xs="12" lg="4" md="6">
                <v-text-field v-model="name"  :label="$t('commission_role.header1')" outlined
                  dense />
              </v-col>
            </v-row>
          </v-card-actions>

          <v-card-actions >
            <v-row>
              <v-col cols="12" xs="12" lg="4" md="6">
                <v-text-field v-model="turnover_from" :label="$t('commission_role.header2')" outlined dense type="number" :rules="[v => /^\d+$/.test(v) || 'กรุณากรอกเป็นจำนวนเต็ม']"/>
              </v-col>
              <v-col cols="12" xs="12" lg="4" md="6">
                <v-text-field v-model="turnover_to" :label="$t('commission_role.header3')" outlined dense  type="number" :rules="[v => /^\d+$/.test(v) || 'กรุณากรอกเป็นจำนวนเต็ม']"/>
              </v-col>
            </v-row>
          </v-card-actions>

          <v-card-actions >
            <v-row>
              <v-col cols="12" xs="12" lg="4" md="6">
                <v-text-field v-model="deposit_from" :label="$t('commission_role.header4')" outlined dense  type="number" :rules="[v => /^\d+$/.test(v) || 'กรุณากรอกเป็นจำนวนเต็ม']"/>
              </v-col>
              <v-col cols="12" xs="12" lg="4" md="6">
                <v-text-field v-model="deposit_to" :label="$t('commission_role.header5')" outlined dense   type="number" :rules="[v => /^\d+$/.test(v) || 'กรุณากรอกเป็นจำนวนเต็ม']"/>
              </v-col>
            </v-row>
          </v-card-actions>

          <v-card-actions >
            <v-row>
              <v-col cols="12" xs="12" lg="4" md="6">
                <v-text-field v-model="commission_min_withdraw" :label="$t('commission_role.header12')" outlined dense  type="number" :rules="[v => /^\d+$/.test(v) || 'กรุณากรอกเป็นจำนวนเต็ม']"/>
              </v-col>
              <v-col cols="12" xs="12" lg="4" md="6">
                <v-text-field v-model="limit_commission" :label="$t('commission_role.header13')" outlined dense  type="number" :rules="[v => /^\d+$/.test(v) || 'กรุณากรอกเป็นจำนวนเต็ม']"/>
              </v-col>
            </v-row>
          </v-card-actions>

          <v-divider class="mx-3" />
          <v-card-actions v-if="commissionMemberType==='all'">
            <v-row>
              <v-col cols="12" xs="12" lg="4" md="6">
                <v-text-field v-model="commission_percent" :label="$t('commission_role.header15')" outlined dense  type="number" />
              </v-col>
            </v-row>
          </v-card-actions>

          <v-card-actions v-if="commissionMemberType==='split'">
            <v-row>
              <v-col cols="12" xs="12" lg="4" md="6">
                <v-text-field v-model="commission_percent_bacara" :label="$t('commission_role.header6')" outlined dense  type="number"/>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions v-if="commissionMemberType==='split'">
            <v-row>
              <v-col cols="12" xs="12" lg="4" md="6">
                <v-text-field v-model="commission_percent_slot" :label="$t('commission_role.header7')" outlined dense  type="number"/>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions v-if="commissionMemberType==='split'">
            <v-row>
              <v-col cols="12" xs="12" lg="4" md="6">
                <v-text-field v-model="commission_percent_sport" :label="$t('commission_role.header8')" outlined dense  type="number"/>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions v-if="commissionMemberType==='split'">
            <v-row>
              <v-col cols="12" xs="12" lg="4" md="6">
                <v-text-field v-model="commission_percent_lottery" :label="$t('commission_role.header9')" outlined dense  type="number"/>
              </v-col>
            </v-row>
          </v-card-actions>

          <v-divider class="mx-3" />
          <v-card-actions >
            <v-row>
              <v-col cols="12" xs="12" lg="4" md="6">
                <v-text-field v-model="cashback_percent" :label="$t('commission_role.header10')" outlined dense  type="number"/>
              </v-col>
              <v-col cols="12" xs="12" lg="4" md="6">
                <v-text-field v-model="cashback_percent_lottery" :label="$t('commission_role.header11')" outlined dense  type="number"/>
              </v-col>
            </v-row>
          </v-card-actions>

          <v-divider class="mx-3" />

          <v-card-actions>
            <v-spacer />
            <v-btn color="warning" @click="$router.push('/commissionRole')">
              <v-icon>mdi-arrow-left</v-icon>
              <span class="px-3">{{ $t('back') }}</span>
            </v-btn>
            <v-btn color="success"  class="px-3" @click="save">
              <v-icon>mdi-content-save</v-icon>
              <span class="px-3">{{ $t('save') }}</span>
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import store from '@/store'

export default {
  components: {
  },
  data() {
    return {
      loading: false,
      formValid: true,
      name:'',
      turnover_from:'',
      turnover_to:'',
      deposit_from:'',
      deposit_to:'',
      commission_percent:'',
      commission_percent_bacara:'',
      commission_percent_slot:'',
      commission_percent_sport:'',
      commission_percent_lottery:'',
      commission_min_withdraw:'',
      limit_commission:'',
      cashback_percent:'',
      cashback_percent_lottery:'',
      breadcrumbsItems: [
        {
          text: this.$t('commission_role.head'),
          disabled: false,
          href: '/commissionRole',
        },
        {
          text: this.$t('commission_role.head_list2'),
          disabled: true,
          href: '',
        },
      ],
      id: this.$route.params.id,
      commissionMemberType:'',
      roles : []
    }
  },
  async created() {
    try {
      this.bankItems = await this.$store.dispatch('getTypeBankData')

      let settingWebInfo = await this.$store.dispatch('getSettingWebInfo')
      this.bankSystem = settingWebInfo?.bank_system[0] || 'TH';
      this.bankConfig = this.banksTypeConfig[this.banksTypeConfig.length - 1].bank
    } catch (e) { }
    try {
      await this.$store.dispatch('getSettingFeature').then(res => {
        this.commissionMemberType = res.filter(item => item.page === 'commissionmember')[0]?.value ;
      })
    } catch (e) {
      console.log("Load Commission Fail");
     }

    await this.addLogPage()
    await this.getCommissionRole()
  },
  methods: {
    async addLogPage() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          data = {
            ip: res.data.ip,
            name: 'ตั้งค่า Commission Role',
            url: window.location.href,
            detail: 'แก้ไข Commission Role',
            admin: userSystem.name ? userSystem.name : '' ? userSystem.name : '',
          }
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
        // if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
        //   this.$swal.fire({
        //     icon: 'error',
        //     title: e.message,
        //   })
        // }
      }
    },
    async getCommissionRole() {
      this.loading = true
      let rs = await this.$store.dispatch('getCommissionRoleById',this.id)
      this.total=1;
      this.name=rs.data[0].name
      this.turnover_from= rs.data[0].condition_amount_from,
      this.turnover_to=rs.data[0].condition_amount_to,
      this.deposit_from= rs.data[0].condition_deposit_amount_from,
      this.deposit_to= rs.data[0].condition_deposit_amount_to,
      this.commission_percent=rs.data[0].commission_percent
      this.commission_percent_bacara= rs.data[0].commission_percent_bacara,
      this.commission_percent_slot=rs.data[0].commission_percent_slot,
      this.commission_percent_sport= rs.data[0].commission_percent_sport,
      this.commission_percent_lottery= rs.data[0].commission_percent_lottery,
      this.commission_min_withdraw= rs.data[0].commission_min_withdraw,
      this.cashback_percent= rs.data[0].cashback_percent,
      this.cashback_percent_lottery=rs.data[0].cashback_percent_lottery,
      this.limit_commission= rs.data[0].limit_commission,

      this.loading = false
    },
    async save() {
      this.loading = true
      let params = {
          id: this.id,
          name: this.name,
          condition_amount_from: this.turnover_from,
          condition_amount_to: this.turnover_to,
          condition_deposit_amount_from: this.deposit_from,
          condition_deposit_amount_to: this.deposit_to,
          commission_percent: this.commission_percent,
          commission_percent_bacara: this.commission_percent_bacara,
          commission_percent_slot: this.commission_percent_slot,
          commission_percent_sport: this.commission_percent_sport,
          commission_percent_lottery: this.commission_percent_lottery,
          commission_min_withdraw: this.commission_min_withdraw,
          cashback_percent: this.cashback_percent,
          cashback_percent_lottery: this.cashback_percent_lottery,
          limit_commission: this.limit_commission,
      }
      try {
          await this.$store.dispatch('updateCommissionRoleById', params)
          this.$swal.fire({
              icon: 'success',
              title: this.$t('upload_complete'),
            })
      } catch (e) {
          if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
            this.$swal.fire({
              icon: 'error',
              title: e.message,
            })
          }
      }
      this.loading = false
    },
  },
}
</script>
